import './bootstrap/bootstrap'

// shido plugins
import dimentions from '../../../node_modules/shido.dimentions.js/src/dimentions.js'
import regular from '../../../node_modules/shido.regular.js/src/regular.js'
import proportional from '../../../node_modules/shido.proportional.js/src/proportional.js'
import forms from '../../../node_modules/shido.forms.js/src/forms.js'

// app
// require('../../../node_modules/...')
require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js')
import 'alpinejs'

import alert from './components/alerts'
import NavAdmin from './components/nav-admin'
import Pincode from './components/pincode'
import StickyJs from './components/sticky'
import Map from './components/map'
import InputIncrement from './components/input-increment'
import flatpickrInput from './components/flatpickr'
import UppyFiles from './components/uppy'
import Fancybox from './components/fancybox'
import Tabs from './components/tabs'
import GetDistributorFolio from './components/get-distributor-folio'
import onChangeSelect from './components/onchange-select'
import enableBtn from './components/enable-btn'
import collapse from './components/collapse'
import SubmitCurpForm from './components/submit-curp-form'
import SearchProducts from './components/search-products';

// Initializers
const docReady = () => {
  new dimentions().init()
  new regular().init()
  new proportional().init()
  new forms().init()
  new alert().session()
  new alert().confirm()
  new flatpickrInput().init()
  new collapse().init()

  NavAdmin()
  Pincode()
  StickyJs()
  InputIncrement()
  Map()
  UppyFiles()
  Fancybox()
  Tabs()
  GetDistributorFolio()
  onChangeSelect()
  enableBtn()
  SubmitCurpForm()
  SearchProducts()
}

const winLoad = () => {
  // ...
}

const docReadyWinload = () => {
  // ...
}

// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener('DOMContentLoaded', () => {
  docReady()
  docReadyWinload()
}, false)
window.addEventListener('load', () => {
  winLoad()
  docReadyWinload()
}, false )
// ---
// ---
